<div
    class="entry"
    [class.phonelink--outlined]="outlined()"
>
    @if (title()) {
        <h3 class="entry__title">
            {{ title() }}
        </h3>
    }

    @if (phone()) {
        <a
            class="entry__link"
            target="_blank"
            [attr.aria-label]="ariaLabel() ?? linkLabel() ?? phone()"
            [href]="'tel:' + phone()"
        >
            <span>
                {{ linkLabel() ?? phone() }}
            </span>
        </a>
    }
</div>
